<script>
import SendPhoneTokenForm from '@phoenix/mixins/components/myAccount/SendPhoneTokenForm';

export default {
  mixins: [SendPhoneTokenForm],

  props: {
    customPiplStatement: {
      type: String,
      default: null,
    },
    actionRouteName: {
      type: String,
      default: 'api.customer.phoneToken.send',
    },
  },

  computed: {
    formAction() {
      return window.route(this.actionRouteName);
    },
  },
};
</script>

<template>
  <phoenix-form
    ref="phoenixForm"
    v-model="fields"
    :action="formAction"
    :show-errors-in-toast="showErrorsInToast"
    :captcha-enabled="true"
    :should-display-submit-button="false"
    :fill-customer-info="false"
    :should-display-required-text="false"
    :on-success-callback="onSuccess"
    :on-fail-callback="onFail"
    :should-display-chinese-pipl-statement="true"
    :custom-pipl-statement="customPiplStatement"
  >
    <slot />
    <template #form-actions>
      <slot name="form-actions" />
    </template>
  </phoenix-form>
</template>
